import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const REVIEWS = [{
  name: 'Valentina',
  text: 'Muchas gracias por esto....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1503104834685-7205e8607eb9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Camila',
  text: 'Esto es increíble, me....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Sofía',
  text: 'Me cambió completamente....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1485875437342-9b39470b3d95?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Martina',
  text: 'Gracias de verdad....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Jazmín',
  text: 'Estoy sorprendida con....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1532170579297-281918c8ae72?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Lucía',
  text: 'Me encantó, súper claro....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Agustina',
  text: 'No suelo dejar mensajes, pero....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Micaela',
  text: 'Me ayudó muchísimo....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Julieta',
  text: 'Qué increíble esto, me dio....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1493666438817-866a91353ca9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Florencia',
  text: 'Me sirvió un montón....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1502323777036-f29e3972d82f?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Paula',
  text: 'Gracias, me dio mucha claridad....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Milagros',
  text: 'Me cambió totalmente la forma....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1593104547489-5cfb3839a3b5?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Catalina',
  text: 'Estoy feliz con esto, superó....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Antonella',
  text: 'Muchas gracias, sentí un....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Brenda',
  text: 'Increíble, de verdad me ayudó....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1601412436009-d964bd02edbc?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Rocío',
  text: 'Lo recomiendo muchísimo....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Malena',
  text: 'Gracias por esto, me hizo....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Lourdes',
  text: 'Me encantó, fue práctico, rápido....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Ailén',
  text: 'No esperaba tanto, pero la....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1596215143922-eb31babd11ce?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Carolina',
  text: 'Me ayudó muchísimo, siento....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Candela',
  text: 'Esto es una locura....',
  time: 'hace 5 minutos',
  img: 'https://images.unsplash.com/photo-1614283233556-f35b0c801ef1?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Belén',
  text: 'Gracias, me dio resultados....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Abril',
  text: 'Me cambió completamente....',
  time: 'hace 7 minutos',
  img: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Tatiana',
  text: 'Súper recomendado, me ayudó....',
  time: 'hace 1 minuto',
  img: 'https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Nazarena',
  text: 'Muchas gracias por esto....',
  time: 'hace 12 minutos',
  img: 'https://images.unsplash.com/photo-1499714608240-22fc6ad53fb2?w=80&h=80&fit=crop&crop=face'
}];
const MAX_REVIEWS = 3399;
function pickRandomReview(prevName?: string) {
  let r = REVIEWS[Math.floor(Math.random() * REVIEWS.length)];
  let attempts = 0;
  while (prevName && r.name === prevName && attempts < 5) {
    r = REVIEWS[Math.floor(Math.random() * REVIEWS.length)];
    attempts++;
  }
  return r;
}
function pickRandomRating() {
  // Range 4.70 → 4.85 inclusive, step 0.01
  const min = 470;
  const max = 485;
  const v = Math.floor(Math.random() * (max - min + 1)) + min;
  return v / 100;
}
function formatNumber(n: number) {
  return n.toLocaleString('es-AR');
}
function formatRating(r: number) {
  return r.toFixed(2).replace('.', ',');
}
export function StickyReviewBar() {
  const [review, setReview] = useState(() => pickRandomReview());
  const [tick, setTick] = useState(0);
  const [reviewCount, setReviewCount] = useState(3003);
  const [rating, setRating] = useState(4.83);
  const [scrolledPastFold, setScrolledPastFold] = useState(false);
  const [inOfferSection, setInOfferSection] = useState(false);
  // Rotate review every 5s
  useEffect(() => {
    const id = setInterval(() => {
      setReview(prev => pickRandomReview(prev.name));
      setTick(t => t + 1);
    }, 5000);
    return () => clearInterval(id);
  }, []);
  // Increment review count every 3s by random 1-4, capped at MAX_REVIEWS
  useEffect(() => {
    const id = setInterval(() => {
      setReviewCount(c => Math.min(c + (Math.floor(Math.random() * 4) + 1), MAX_REVIEWS));
    }, 3000);
    return () => clearInterval(id);
  }, []);
  // Rotate rating every 10s within [4.70, 4.85]
  useEffect(() => {
    const id = setInterval(() => {
      setRating(prev => {
        let next = pickRandomRating();
        let attempts = 0;
        while (next === prev && attempts < 5) {
          next = pickRandomRating();
          attempts++;
        }
        return next;
      });
    }, 10000);
    return () => clearInterval(id);
  }, []);
  // Detect scroll past above-the-fold
  useEffect(() => {
    const onScroll = () => {
      setScrolledPastFold(window.scrollY > window.innerHeight * 0.6);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  // Detect when user is inside the offer section
  useEffect(() => {
    const el = document.getElementById('oferta');
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setInOfferSection(entry.isIntersecting);
    }, {
      rootMargin: '-10% 0px -40% 0px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const ctaVisible = scrolledPastFold && !inOfferSection;
  const scrollToOffer = () => {
    const target = document.getElementById('oferta-header');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  // Compute fractional fill of the last star from current rating
  const lastStarFillPct = Math.max(0, Math.min(100, Math.round((rating - 4) * 100)));
  return <div className="fixed top-0 left-0 right-0 z-[80] bg-gradient-to-r from-[#1B5E20] via-[#2E7D32] to-[#1B5E20] border-b-2 border-[#FF6F00] shadow-[0_4px_18px_rgba(0,0,0,0.18)]" data-id="element-530">
      <div className="max-w-5xl mx-auto px-3 py-2 md:px-4 md:py-2.5" data-id="element-531">
        <div className="flex items-center gap-3" data-id="element-532">
          {/* Left side: stars + rotating review */}
          <div className="flex flex-col min-w-0 flex-1" data-id="element-533">
            {/* Stars + rating + reviews counter */}
            <div className="flex items-center gap-1.5" data-id="element-534">
              <AnimatePresence mode="popLayout" data-id="element-535">
                <motion.span key={rating} initial={{
                opacity: 0,
                y: -4
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 4
              }} transition={{
                duration: 0.3
              }} className="font-black text-white text-sm md:text-base leading-none tabular-nums inline-block" data-id="element-536">
                  {formatRating(rating)}
                </motion.span>
              </AnimatePresence>
              <div className="flex items-center gap-0.5" data-id="element-537">
                {[0, 1, 2, 3].map(i => <Star key={i} className="w-3.5 h-3.5 fill-[#FFC107] text-[#FFC107]" data-id="element-538" />)}
                {/* Partial star — reflects fractional part of rating */}
                <div className="relative w-3.5 h-3.5 inline-block" data-id="element-539">
                  <Star className="absolute inset-0 w-3.5 h-3.5 text-[#FFC107]" data-id="element-540" />
                  <motion.div className="absolute inset-0 overflow-hidden" animate={{
                  width: `${lastStarFillPct}%`
                }} transition={{
                  duration: 0.4,
                  ease: 'easeOut'
                }} data-id="element-541">
                    <Star className="w-3.5 h-3.5 fill-[#FFC107] text-[#FFC107]" data-id="element-542" />
                  </motion.div>
                </div>
              </div>
              <span className="text-white/85 text-[11px] md:text-xs font-medium leading-none" data-id="element-543">
                <motion.span key={reviewCount} initial={{
                opacity: 0,
                y: -3
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.25
              }} className="font-bold text-[#FFC107] tabular-nums inline-block" data-id="element-544">
                  {formatNumber(reviewCount)}
                </motion.span>{' '}
                reviews
              </span>
            </div>

            {/* Rotating review — single line with avatar */}
            <div className="relative h-[18px] md:h-[20px] overflow-hidden mt-1" data-id="element-545">
              <AnimatePresence mode="wait" data-id="element-546">
                <motion.div key={tick} initial={{
                opacity: 0,
                y: 8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -8
              }} transition={{
                duration: 0.35,
                ease: [0.16, 1, 0.3, 1]
              }} className="absolute inset-0 flex items-center gap-1.5" data-id="element-547">
                  <img src={review.img} alt={review.name} className="w-[18px] h-[18px] md:w-5 md:h-5 rounded-full shrink-0 object-cover ring-1 ring-white/40 bg-white/10" loading="lazy" data-id="element-548" />
                  <p className="truncate text-[11px] md:text-xs text-white/95 leading-tight" data-id="element-549">
                    <span className="font-bold text-white" data-id="element-550">{review.name}:</span>{' '}
                    <span className="text-white/85" data-id="element-551">{review.text}</span>
                    <span className="text-white/45" data-id="element-552"> — {review.time}</span>
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

          {/* Floating CTA button */}
          <AnimatePresence data-id="element-553">
            {ctaVisible && <motion.button type="button" initial={{
            scale: 0,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} exit={{
            scale: 0,
            opacity: 0
          }} transition={{
            type: 'spring',
            stiffness: 320,
            damping: 22
          }} onClick={scrollToOffer} className="relative shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFC107] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1B5E20] rounded-full" aria-label="Lo quiero — ir a la oferta" data-id="element-554">
                {/* Glow */}
                <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full bg-[#FF6F00] blur-lg opacity-70 animate-pulse" data-id="element-555" />
                {/* Shine sweep */}
                <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full overflow-hidden" data-id="element-556">
                  <span className="absolute -inset-1 bg-gradient-to-r from-transparent via-white/55 to-transparent -translate-x-full animate-[shimmer_2.2s_infinite]" data-id="element-557" />
                </span>
                <span className="relative inline-flex items-center gap-1 bg-gradient-to-b from-[#FF8A00] to-[#FF6F00] hover:from-[#FF7A00] hover:to-[#E65100] text-white text-[11px] md:text-sm font-black tracking-wide rounded-full px-3.5 py-2 md:px-5 md:py-2.5 shadow-[0_6px_16px_rgba(255,111,0,0.55),inset_0_1px_0_rgba(255,255,255,0.35)] transition-colors whitespace-nowrap" data-id="element-558">
                  LO QUIERO →
                </span>
              </motion.button>}
          </AnimatePresence>
        </div>
      </div>
    </div>;
}